import React from 'react';
import { IconsPros } from './types';

/**
 * Wordpress Icon component
 *
 * @returns JSX.ELEMENT
 */
export const WordpressIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M14,4.71a6.86,6.86,0,0,1-2.57,9.22l2.1-6.06a6.47,6.47,0,0,0,.52-2.46A5.27,5.27,0,0,0,14,4.71ZM8.12,8.6l2.11,5.78,0,.09a6.86,6.86,0,0,1-4.22.11Zm4.51-.95a8.29,8.29,0,0,1-.52,2.22l-.68,2.29L8.94,4.78c.41,0,.79-.07.79-.07a.28.28,0,0,0,0-.57s-1.11.09-1.83.09S6,4.15,6,4.15a.28.28,0,0,0,0,.57s.35,0,.72.07L7.79,7.71l-1.5,4.5L3.79,4.78c.41,0,.79-.07.79-.07a.28.28,0,0,0,0-.57s-1.11.09-1.83.09H2.27A6.86,6.86,0,0,1,12.63,2.94h-.09a1.19,1.19,0,0,0-1.15,1.22,3.21,3.21,0,0,0,.67,1.61A3.61,3.61,0,0,1,12.63,7.65ZM1.14,8a6.84,6.84,0,0,1,.59-2.79l3.27,9A6.86,6.86,0,0,1,1.14,8ZM8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0M8,15.63A7.63,7.63,0,1,1,15.63,8,7.64,7.64,0,0,1,8,15.63" />
    </svg>
  );
};
